// src/resources/commentReports/constants.js

export const COMMENT_REPORT_STATUS_CONFIG = [
    { status: 'NEW', label: 'Nouveaux', color: 'error' },
    { status: 'REVIEWING', label: 'En revue', color: 'warning' },
    { status: 'RESOLVED', label: 'Résolus', color: 'success' },
    { status: 'DISMISSED', label: 'Classés', color: 'default' },
];

export const COMMENT_REPORT_STATUS_CHOICES = COMMENT_REPORT_STATUS_CONFIG.map(
    ({ status, label }) => ({
        id: status,
        name: label,
    }),
);

export const COMMENT_REPORT_STATUS_LABELS = COMMENT_REPORT_STATUS_CONFIG.reduce(
    (acc, { status, label }) => {
        acc[status] = label;
        return acc;
    },
    {},
);
